module.exports = __webpack_public_path__ + "static/img/example4.9ae2491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/example4.jpg
// module id = UnjK
// module chunks = 1